import { NgZone } from '@angular/core';
import { NEVER, Observable, Subject } from 'rxjs';
import { ConnectionState, ServerEventMessage } from '../../models';
import { ServerEventsProviderService } from '../server-events-provider-base/server-events-provider-base';

export class ServerEventsProviderMock extends ServerEventsProviderService {
  private static readonly subject = new Subject<ServerEventMessage>();

  constructor(private zone: NgZone) {
    super();
    window['triggerPusherEvent'] = this.triggerPusherEvent.bind(this);
  }

  getServerEventsFeed(): Observable<ServerEventMessage<any>> {
    return ServerEventsProviderMock.subject;
  }

  getConnectionState(): Observable<ConnectionState> {
    return NEVER;
  }

  getLogs(): Observable<any> {
    return NEVER;
  }

  private triggerPusherEvent(serverEventMessage: ServerEventMessage): void {
    this.zone.run(() => ServerEventsProviderMock.subject.next(serverEventMessage));
  }
}
